import { useRef, useState } from 'react'
import { useRecoilState } from 'recoil'
import { NavLink } from 'react-router-dom'
import clsx from 'clsx'
import IconMenu from '@/components/icons/IconMenu'
import IconColorMenu from '@/components/icons/IconColorMenu'
import { marketSymbolState } from '@/recoil/Market'
import useOnClickOutside from '@/hooks/useOnClickOutside'

import './Menu.css'

export default function Menu() {
  const [marketSymbol] = useRecoilState(marketSymbolState)
  const [isActive, setIsActive] = useState(false)
  const menuRef = useRef()
  useOnClickOutside(menuRef, () => setIsActive(false))
  const tradePagePath = `/trade/${marketSymbol}`
  const closeMenu = () => setIsActive(false)
  return (
    <div ref={menuRef} className="header-icon-button-container">
      <div
        className="header-icon-button"
        onClick={() => setIsActive(active => !active)}
      >
        {isActive ? <IconColorMenu /> : <IconMenu />}
      </div>
      <div className={clsx('menu-list', { active: isActive })}>
        <NavLink className="menu-list-row" to="/account" onClick={closeMenu}>
          Account
        </NavLink>
        <NavLink
          className="menu-list-row"
          to={tradePagePath}
          onClick={closeMenu}
        >
          Trade
        </NavLink>
        <NavLink className="menu-list-row" to="/markets" onClick={closeMenu}>
          Market
        </NavLink>
      </div>
    </div>
  )
}
